import React, { useEffect, useRef, useState } from "react";
import "../styles/NavbarStyles.css";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import searchicon from "../assets/icons/search-icon.png";
import telephone from "../assets/icons/telephone.png";
import { useNavigate } from "react-router-dom";
import theme from "../theme/theme";
import logo from "../assets/TimeWatchlogo.png";
import mailIcon from "../assets/icons/mail.png";
import fbIcon from "../assets/icons/facebook.png";
import instaIcon from "../assets/icons/instagram.png";
import whatsappIcon from "../assets/icons/whatsapp.png";
import twitterIcon from "../assets/icons/twitter.png";
import pinterestIcon from "../assets/icons/pinterest.png";
import linkedinIcon from "../assets/icons/linkedin.png";
import youtubeIcon from "../assets/icons/youtube.png";
import appIcon from "../assets/icons/playstore.png";
import ios from "../assets/icons/apple.png";
import productsData from "../data/products.json";
import insightsData from "../data/insights.json";
import { FaBars, FaSearch, FaTimes } from "react-icons/fa";
import { NavLink, Link } from "react-router-dom";
import seoFriendlySlug from "../utils/seoFriendlySlug";

function Navbar() {
  const searchRef = useRef();
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae" : "/";
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smooth scrolling
    });
  };
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const marketplace = `${basePath}market-place`;
  const downloads = `${basePath}downloads`;
  const about = `${basePath}about-us`;
  const ceodesk = `${basePath}ceo-desk`;
  const contact = `${basePath}contact-us`;

  const email = isUAEPath ? "ceo@timewatchuae.com" : "sales@timewatchindia.com";

  const phone = isUAEPath ? "+971-54-777-0637" : "+91-95999 53923";

  const insta = isUAEPath
    ? "https://www.instagram.com/timewatchuaeinfocom"
    : "https://www.instagram.com/timewatchindiainfocom/";

  const facebook = isUAEPath
    ? "https://www.facebook.com/timewatchuae/"
    : "https://www.facebook.com/TimeWatchindia1";

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    // Check screen size on initial load
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleMouseEnter = () => {
    setDropdownVisible(true);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showSuggestions, setShowSugesstions] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    setShowSugesstions(true);

    if (value.trim() === "") {
      setFilteredProducts([]); // Reset when input is empty
      return;
    }

    const results = productsData.products
      .map((category) => {
        const matchingSubCategories = category.subCategories
          .map((subCategory) => {
            const matchingProducts = subCategory.products.filter((product) =>
              product.productName.toLowerCase().includes(value)
            );

            if (
              subCategory.subCategoryName.toLowerCase().includes(value) ||
              matchingProducts.length > 0
            ) {
              return { ...subCategory, products: matchingProducts };
            }
            return null;
          })
          .filter(Boolean); // Filter out null subcategories

        if (
          category.categoryName.toLowerCase().includes(value) ||
          matchingSubCategories.length > 0
        ) {
          return { ...category, subCategories: matchingSubCategories };
        }

        return null;
      })
      .filter(Boolean); // Filter out null categories

    setFilteredProducts(results);
  };

  const handleItemClick = (category, subCategory, product) => {
    const encodedCategory = encodeURIComponent(category);
    const encodedSubCategory = subCategory
      ? encodeURIComponent(subCategory)
      : null;
    const encodedProduct = product ? encodeURIComponent(product) : null;

    if (encodedProduct) {
      navigate(
        `${basePath}market-place/${seoFriendlySlug(
          encodedCategory
        )}/${seoFriendlySlug(encodedSubCategory)}/${seoFriendlySlug(
          encodedProduct
        )}`
      );
    } else if (encodedSubCategory) {
      navigate(
        `${basePath}market-place/${seoFriendlySlug(
          encodedCategory
        )}/${seoFriendlySlug(encodedSubCategory)}`
      );
    } else {
      navigate(`${basePath}market-place/${seoFriendlySlug(encodedCategory)}`);
    }

    setFilteredProducts([]); // Close the dropdown after clicking
  };

  const handleMouseLeave = () => {
    // Delay hiding the dropdown to allow smooth transition
    setTimeout(() => {
      setDropdownVisible(false);
    }, 300); // 300ms delay before hiding
  };

  const [isProductsHovered, setIsProductsHovered] = useState(true);
  const [isInsightsHovered, setIsInsightsHovered] = useState(false);
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  useEffect(()=>{
    const handleClickOutSide = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowSugesstions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutSide);

    return () => {
      document.removeEventListener("mousedown", handleClickOutSide);
    }
  },[])

  useEffect(() => {


    if (isProductsHovered && productsData?.products?.length > 0) {
      setSelectedCategory(0);
    }
  }, [isProductsHovered, productsData]);

  return (
    <>
      <header className="navbar-header">
        {/* Top Thin Strip */}
        <div className="top-strip py-1 d-none d-xl-block bg-white">
          <Container fluid>
            {" "}
            {/* Use fluid container for full-width behavior */}
            <Row className="d-flex justify-content-between align-items-center mx-0">
              {" "}
              {/* Remove default spacing */}
              {/* Left Part */}
              <Col xs={12} md="auto" className="d-flex align-items-center px-0">
                {" "}
                {/* Remove padding from sides */}
                <a
                  href={`mailto:${email}`}
                  className="text-decoration-none d-flex align-items-center me-3"
                  style={{ color: theme.colors.topStripText }}
                >
                  <img
                    src={mailIcon}
                    alt="Email"
                    className="me-2"
                    style={{ width: "20px" }}
                  />
                  <span>{email}</span>
                </a>
                <a
                  href={`tel:${phone}`}
                  className="text-decoration-none d-flex align-items-center"
                  style={{ color: theme.colors.topStripText }}
                >
                  <img
                    src={telephone}
                    alt="Call"
                    className="me-2"
                    style={{ width: "20px" }}
                  />
                  <span>{phone} </span>
                </a>
              </Col>
              {/* Right Part */}
              <Col xs={12} md="auto" className="d-flex align-items-center px-0">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-12 col-md-0">
                      <div className="input-group mb-0">
                        <input
                          className="form-control search-input"
                          placeholder="Search products..."
                          value={searchTerm}
                          onChange={handleSearch}
                        />
                        <span className="input-group-text bg-white">
                          <img
                            src={searchicon}
                            alt="Search Icon"
                            className="img-fluid"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* Conditionally render the search results dropdown only when there are results */}
                  {showSuggestions && searchTerm.trim() !== "" && (
                    <div className="row justify-content-center">
                      <div>
                        <div
                          className="dropdown-menu show w-10 suggestion-bar"
                          ref={searchRef}
                          style={{
                            maxHeight: "500px",
                            overflowY: "auto",
                            minWidth: "450px",
                          }}
                        >
                          {filteredProducts.length > 0 ? (
                            filteredProducts.map((product, index) => (
                              <div key={index}>
                                {product.subCategories.map(
                                  (subCategory, subIndex) =>
                                    subCategory.products
                                      .filter((prod) =>
                                        prod?.productName
                                          ?.toLowerCase()
                                          .includes(searchTerm.toLowerCase())
                                      )
                                      .map((prod, prodIndex) => (
                                        <p
                                          key={prodIndex}
                                          onClick={() => {
                                            scrollToTop();
                                            handleItemClick(
                                              product.categoryName,
                                              subCategory.subCategoryName,
                                              prod.productName
                                            );
                                            setSearchTerm("")
                                            // setShowSugesstions(false);
                                          }}
                                          className="dropdown-item hover-color mb-0 cursor-pointer"
                                        >
                                          <FaSearch />
                                          <span>{prod.productName}</span>
                                        </p>
                                      ))
                                )}
                              </div>
                            ))
                          ) : (
                            <div className="dropdown-item text-muted text-center">
                              No results found
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Remove padding from sides */}
                {!isUAEPath && (
                  <Link
                    to="/become-partner"
                    className="btn  me-3"
                    onClick={scrollToTop}
                    style={{
                      padding: "8px 10px",
                      textWrap: "nowrap",
                      border: "1px solid",
                      borderColor: "#000000",
                      textDecoration: "none",
                      borderRadius: "50px",
                    }}
                  >
                    Become Partner
                  </Link>
                )}
                <div className="d-flex gap-1">
                  {!isUAEPath && (
                    <a
                      href="https://wa.me/919599953923?text=Hello%F0%9F%91%8B%F0%9F%8F%BB%20TimeWatch%2C%0AI%27m%20Interested%20in%20your%20product%20or%20services%0APlease%20Assist%20me%21%20%20"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={whatsappIcon}
                        alt="WhatsApp"
                        className="me-2"
                        style={{ width: "40px" }}
                      />
                    </a>
                  )}
                  <a
                    href={`${insta}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={instaIcon}
                      alt="Instagram"
                      className="me-2"
                      style={{ width: "40px" }}
                    />{" "}
                    {/* Reduce icon size */}
                  </a>
                  <a
                    href={`${facebook}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={fbIcon}
                      alt="Facebook"
                      className="me-2"
                      style={{ width: "40px" }}
                    />{" "}
                    {/* Reduce icon size */}
                  </a>
                  <a
                    href="https://www.linkedin.com/company/timewatchindia/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={linkedinIcon}
                      alt="LinkedIn"
                      className="me-2"
                      style={{ width: "40px" }}
                    />{" "}
                    {/* Reduce icon size */}
                  </a>
                  <a
                    href="https://www.youtube.com/@Timewatchinfocomindia"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={youtubeIcon}
                      alt="YouTube"
                      className="me-2"
                      style={{ width: "40px" }}
                    />{" "}
                    {/* Reduce icon size */}
                  </a>
                  <a
                    href="https://in.pinterest.com/timewatchinfocom/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={pinterestIcon}
                      alt="Pinterest"
                      className="me-2"
                      style={{ width: "40px" }}
                    />{" "}
                    {/* Reduce icon size */}
                  </a>
                  <a
                    href="https://twitter.com/timewatchbiome"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={twitterIcon}
                      alt="Twitter"
                      className="me-2"
                      style={{ width: "40px" }}
                    />{" "}
                    {/* Reduce icon size */}
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.timewatch.phoneapp&hl=en_IN&pli=1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={appIcon} alt="App" style={{ width: "40px" }} />{" "}
                    {/* Reduce icon size */}
                  </a>
                  <a
                    href="https://apps.apple.com/in/app/timewatch-mobile-attendance/id6482852039"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={ios} alt="App" style={{ width: "50px" }} />{" "}
                    {/* Reduce icon size */}
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Main Navbar */}
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            {/* Logo Section */}
            <div className="row align-items-center">
              {/* Logo at the left */}
              <div className="col-auto">
                <NavLink to={`${basePath}`} onClick={scrollToTop}>
                  <img
                    className="logo-image img-fluid" // img-fluid for responsive images
                    src={logo}
                    alt="timewatch"
                    // Custom size for the logo
                  />
                </NavLink>
              </div>
            </div>

            {/* Toggler for mobile view */}
            <button
              className="navbar-toggler"
              type="button"
              onClick={handleClick}
              aria-controls="navbarNav"
              aria-expanded={click}
              aria-label="Toggle navigation"
            >
              {click ? (
                <FaTimes size={30} style={{ color: "black" }} />
              ) : (
                <FaBars size={30} style={{ color: "black" }} />
              )}
            </button>

            {/* Navbar Items */}
            <div
              className={`collapse navbar-collapse ${click ? "show" : ""}`}
              id="navbarNav"
            >
              <ul className="navbar-nav mx-auto">
                <li className="nav-item mx-3 fw-bold fs-6 fs-sm-5 fs-md-4 fs-lg-3 mb-0">
                  <NavLink
                    to={basePath}
                    className="nav-link"
                    activeclassname="active-link"
                    onClick={scrollToTop}
                  >
                    Home
                  </NavLink>
                </li>

                <li
                  className="nav-item mx-3 fw-bold fs-6 fs-sm-5 fs-md-4 fs-lg-3 mb-0"
                  onMouseEnter={() => setIsProductsHovered(true)}
                  onMouseLeave={() => setIsProductsHovered(false)}
                >
                  <NavLink
                    to={`${marketplace}`}
                    className="nav-link"
                    activeclassname="active-link"
                    onClick={scrollToTop}
                  >
                    Products
                  </NavLink>
                  {productsData?.products?.length > 0 && (
                    <div
                      className="dropdown-menu show products-dropdown container"
                      style={{
                        overflowX: "hidden",
                        scrollbarWidth: "none", // For Firefox
                        msOverflowStyle: "none",
                      }}
                    >
                      <div className="row">
                        {/* Left column: Categories (Fixed Height and Non-scrollable) */}

                        <div className="col-md-4 category-list p-2 text-center md-none d-flex flex-column">
                          {productsData.products.map((category, index) => (
                            <p
                              key={index}
                              className={`category-name ${
                                selectedCategory === index
                                  ? "active-category"
                                  : ""
                              }`}
                              onClick={() => setSelectedCategory(index)}
                              style={{
                                cursor: "pointer",
                                fontWeight: "bold",
                                color:
                                  selectedCategory === index
                                    ? "#000000"
                                    : "#000000",
                                backgroundColor:
                                  selectedCategory === index
                                    ? "rgba(193, 191, 191, 1)"
                                    : "rgba(217, 217, 217, 0.43)",
                              }}
                            >
                              {category.categoryName}
                            </p>
                          ))}
                        </div>

                        {/* Right column: Subcategories and Products (Scrollable) */}
                        <div
                          className="col-md-8"
                          style={{
                            overflowY: "auto",
                            scrollbarWidth: "none", // For Firefox
                            msOverflowStyle: "none",
                          }}
                        >
                          <div className="subcategory-products-list d-flex flex-column">
                            {productsData.products[selectedCategory]
                              ?.subCategories?.length > 0 && (
                              <div className="row">
                                {productsData.products[
                                  selectedCategory
                                ].subCategories.map((subCategory, subIndex) => (
                                  <div
                                    key={subIndex}
                                    className="col-12 col-sm-6 col-md-4 subcategory-box mb-3"
                                  >
                                    <h4
                                      className="subcategory-name mb-0"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      <Link
                                        to={`${basePath}market-place/${seoFriendlySlug(
                                          productsData.products[
                                            selectedCategory
                                          ].categoryName
                                        )}/${seoFriendlySlug(
                                          subCategory.subCategoryName
                                        )}`}
                                        onClick={scrollToTop}
                                        style={{
                                          textDecoration: "none",
                                          color: "#f14144",
                                        }}
                                      >
                                        {subCategory.subCategoryName}
                                      </Link>
                                    </h4>
                                    {subCategory?.products?.length > 0 && (
                                      <ul
                                        className="product-list"
                                        style={{
                                          paddingLeft: "0",
                                          wordWrap: "break-word",
                                          overflow: "hidden",
                                        }}
                                      >
                                        {subCategory.products.map(
                                          (product, productIndex) => (
                                            <li
                                              key={productIndex}
                                              style={{
                                                listStyle: "none",
                                                fontSize: "12px",
                                                wordWrap: "break-word",
                                              }}
                                            >
                                              <Link
                                                to={`${basePath}market-place/${seoFriendlySlug(
                                                  productsData.products[
                                                    selectedCategory
                                                  ].categoryName
                                                )}/${seoFriendlySlug(
                                                  subCategory.subCategoryName
                                                )}/${seoFriendlySlug(
                                                  product.productName
                                                )}`}
                                                onClick={scrollToTop}
                                                style={{
                                                  textDecoration: "none",
                                                  color: "#000000",
                                                }}
                                              >
                                                {product.productName}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </li>

                <li className="nav-item mx-3 fw-bold fs-6 fs-sm-5 fs-md-4 fs-lg-3 mb-0">
                  <NavLink
                    to={`${downloads}`}
                    className="nav-link"
                    activeclassname="active-link"
                    onClick={scrollToTop}
                  >
                    Downloads
                  </NavLink>
                </li>

                {!isUAEPath && (
                  <li
                    className="nav-item mx-3 fw-bold fs-6 fs-sm-5 fs-md-4 fs-lg-3 mb-0"
                    onMouseEnter={() => setIsInsightsHovered(true)}
                    onMouseLeave={() => setIsInsightsHovered(false)}
                  >
                    <Link className="nav-link" onClick={scrollToTop}>
                      Insights
                    </Link>
                    {isInsightsHovered && (
                      <div className="dropdown-menu show insights-dropdown">
                        {insightsData.insights.map((insight, index) => (
                          <Link
                            key={index}
                            to={insight.link}
                            className="dropdown-item"
                            onClick={scrollToTop}
                          >
                            {insight.categoryName}
                          </Link>
                        ))}
                      </div>
                    )}
                  </li>
                )}

                <li className="nav-item mx-3 fw-bold fs-6 fs-sm-5 fs-md-4 fs-lg-3 mb-0">
                  <NavLink
                    to={`${about}`}
                    className="nav-link"
                    activeclassname="active-link"
                    onClick={scrollToTop}
                  >
                    About Us
                  </NavLink>
                </li>
                <li className="nav-item mx-3 fw-bold fs-6 fs-sm-5 fs-md-4 fs-lg-3 mb-0">
                  <NavLink
                    to={`${ceodesk}`}
                    className="nav-link"
                    activeclassname="active-link"
                    onClick={scrollToTop}
                  >
                    CEO's Desk
                  </NavLink>
                </li>
              </ul>

              {/* Contact Us Button */}

              <Link
                to={`https://eazypay.icicibank.com/eazypayLink?P1=b65SESRZWRLVerKiBAGNcA==`}
                target="_blank"
                className="payment-btn me-3"
              >
                Pay Now
              </Link>
              <Link
                to={`${contact}`}
                className="btn contact-button"
                onClick={scrollToTop}
                style={{
                  backgroundColor: "#f14144",
                  color: "#ffffff",
                  border: "3px solid #f14144",
                  transition: "all 0.3s",
                  textDecoration: "none",
                  borderRadius: "100px",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.color = "#f14144";
                  e.currentTarget.style.backgroundColor = "#ffffff";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.color = "#ffffff";
                  e.currentTarget.style.backgroundColor = "#f14144";
                }}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Navbar;
